import { render, staticRenderFns } from "./ItemListSpedizione.vue?vue&type=template&id=e81df2aa"
import script from "./ItemListSpedizione.vue?vue&type=script&lang=ts"
export * from "./ItemListSpedizione.vue?vue&type=script&lang=ts"
import style0 from "./ItemListSpedizione.vue?vue&type=style&index=0&id=e81df2aa&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e81df2aa')) {
      api.createRecord('e81df2aa', component.options)
    } else {
      api.reload('e81df2aa', component.options)
    }
    module.hot.accept("./ItemListSpedizione.vue?vue&type=template&id=e81df2aa", function () {
      api.rerender('e81df2aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemListSpedizione.vue"
export default component.exports